const key = "267924688af147b19e9d7a1614958e7c";

//78b9f0c836c04e14a9ba74bdd12ad5d3

export default key;
